import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "listall" }

import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import useLocale from "@/hooks/useLocale"; // 国际化hook

export default /*#__PURE__*/_defineComponent({
  __name: 'NavPopup',
  props: {
  showNavPopup: Boolean,
},
  emits: ["custom-event"],
  setup(__props, { emit: __emit }) {

const {
  i18n: { t }, // 解构实例用具t 访问语言变量
  changeLocale, // 修改国际化
} = useLocale();
let $emit = __emit;
const router = useRouter();
const route = useRoute();
const props = __props;
function navToPrice() {
  $emit("custom-event", false);
  router.push("/mb_price");
}

function navToAbout() {
  $emit("custom-event", false);
  router.push("/mb_about");
}
function navToHome() {
  $emit("custom-event", false);
  router.push("/mb_home");
}
function scrollView(id: string) {
  if (route.path == "/mb_home") {
    document.querySelector(`#${id}`)!.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    $emit("custom-event", false);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "topall",
    style: _normalizeStyle({ height: __props.showNavPopup ? '70rem' : '0' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "top",
        onClick: navToHome
      }, _toDisplayString(_unref(t)("topBar.homepage")), 1),
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollView('demand')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.requirement")), 1),
      _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollView('work')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.workItem")), 1),
      _createElementVNode("span", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollView('test')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.test")), 1),
      _createElementVNode("span", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollView('base')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.baseline")), 1),
      _createElementVNode("span", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (scrollView('change')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.change")), 1),
      _createElementVNode("span", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (scrollView('release')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.publish")), 1),
      _createElementVNode("span", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (scrollView('online')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.onlineJudge")), 1),
      _createElementVNode("span", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (scrollView('docu')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.document")), 1),
      _createElementVNode("span", {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (scrollView('agile')))
      }, _toDisplayString(_unref(t)("homepage.cooperation.agile")), 1),
      _createElementVNode("div", {
        class: "top",
        onClick: navToPrice
      }, _toDisplayString(_unref(t)("topBar.price")), 1),
      _createElementVNode("span", {
        onClick: navToAbout,
        class: "about"
      }, _toDisplayString(_unref(t)("topBar.aboutUs")), 1)
    ])
  ], 4))
}
}

})